export const getAvailabilityConfig = (value) => {
    switch (Number(value)) {
        case 0:
            return {
                value:value,
                labelKey: "available",
                color: "#2E7D32",
            };

        case 1:
            return {
                value:value,
                labelKey: "limited",
                color: "#ED6C02",
            };

        case 2:
            return {
                value:value,
                labelKey: "on_order",
                color: "#0288D1",
            };

        case 3:
            return {
                value:value,
                labelKey: "unavailable",
                color: "#9E9E9E",
            };

        default:
            return {
                value:value,
                labelKey: "",
                color: "#9E9E9E",
            };
    }
};